/**
 * Configuration des champs conditionnels par catégorie de produit
 *
 * Cette configuration définit quels champs additionnels doivent être affichés
 * dans le formulaire de création/édition de produit selon la catégorie sélectionnée.
 */

// Catégories nécessitant le champ gender (genre)
export const GENDER_CATEGORIES = [
  'clothing_men',
  'clothing_women',
  'clothing_kids',
  'shoes',
  'beauty_cosmetics',
  'sports_fitness',
  'jewelry_watches',
] as const;

// Catégories nécessitant le champ sizes (tailles)
export const SIZES_CATEGORIES = [
  'clothing_men',
  'clothing_women',
  'clothing_kids',
  'shoes',
  'sports_fitness',
] as const;

// Catégories nécessitant les champs weight/weightUnit (poids)
export const WEIGHT_CATEGORIES = [
  'groceries',
  'local_products',
  'health_wellness',
  'beauty_cosmetics',
  'pets',
] as const;

// Types pour une meilleure inférence TypeScript
export type GenderCategory = (typeof GENDER_CATEGORIES)[number];
export type SizesCategory = (typeof SIZES_CATEGORIES)[number];
export type WeightCategory = (typeof WEIGHT_CATEGORIES)[number];
